module.exports = __webpack_public_path__ + "static/media/51_tn.9cb8a52c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/51_tn.jpg
// module id = 539
// module chunks = 0